import { Switch } from 'components/atoms/Buttons/Switchs/Switch';
import { useSelector, useDispatch } from 'react-redux';
import { AppState } from 'store/reducers';
import { MainFormState } from 'types/forms/form.def';
import { addClient as addClientAction } from 'store/actions';
import { errorAndStateParams } from 'helpers/forms/errorAndStateParams';
import usePublicShop from 'hooks/usePublicShop';
import useStyle from './policyField.style';
import React from 'react';

const PolicyField = () => {
  const classes = useStyle();
  const { isPublicShop } = usePublicShop();
  const { client } = useSelector((state: AppState) => state);
  const dispatch = useDispatch();
  const addClient = (newParams: MainFormState<any>) =>
    dispatch(addClientAction(newParams));

  const handleChange = async e => {
    const value = e.target.value;
    const field = e.target.name;

    if (client.values.affilie || !client.values.livraisonhorslycee) {
      client.errors = {
        ...client.errors,
        mobilelivraison: false,
        nomlivraison: false,
        prenomlivraison: false
      };
    }

    if (field === 'clientpro' && value === 'false') {
      client.values = { ...client.values, nomsociete: null };
    }

    const newParams = errorAndStateParams(field, value, client);
    addClient(newParams);
  };
  const handleChangeSwitch = (value, name) => {
    const e = {
      target: {
        value: value.toString(),
        name: name
      }
    };
    handleChange(e);
  };

  return (
    <>
      <p>
        Je reconnais avoir pris connaissance des{' '}
        {isPublicShop ? (
          <a
            className={classes.root}
            target="_blank"
            rel="noopener noreferrer"
            href="https://drive.google.com/file/d/1l_ZSaCXIHgLih4RGwUGZLzshMUPQ3a-z/view?usp=sharing"
          >
            conditions générales de vente
          </a>
        ) : (
          'conditions générales de vente'
        )}{' '}
        et je les accepte.
      </p>
      <Switch
        onClick={value => handleChangeSwitch(value, 'policy')}
        defaultValue={client.values.policy}
      />
    </>
  );
};
export default PolicyField;
